var map = {
	"./ion-action-sheet.entry.js": [
		2499,
		2499
	],
	"./ion-alert.entry.js": [
		7073,
		9047
	],
	"./ion-app_8.entry.js": [
		3464,
		3464
	],
	"./ion-avatar_3.entry.js": [
		5700,
		5700
	],
	"./ion-back-button.entry.js": [
		1509,
		1509
	],
	"./ion-backdrop.entry.js": [
		2470,
		2470
	],
	"./ion-button_2.entry.js": [
		4099,
		4099
	],
	"./ion-card_5.entry.js": [
		9441,
		9441
	],
	"./ion-checkbox.entry.js": [
		8129,
		8129
	],
	"./ion-chip.entry.js": [
		2519,
		2519
	],
	"./ion-col_3.entry.js": [
		3507,
		3507
	],
	"./ion-datetime_3.entry.js": [
		7166,
		7166
	],
	"./ion-fab_3.entry.js": [
		9701,
		9701
	],
	"./ion-img.entry.js": [
		9753,
		9753
	],
	"./ion-infinite-scroll_2.entry.js": [
		1582,
		1582
	],
	"./ion-input.entry.js": [
		4465,
		4465
	],
	"./ion-item-option_3.entry.js": [
		4860,
		4860
	],
	"./ion-item_8.entry.js": [
		1973,
		1973
	],
	"./ion-loading.entry.js": [
		5305,
		5305
	],
	"./ion-menu_3.entry.js": [
		9236,
		9236
	],
	"./ion-modal.entry.js": [
		5605,
		5605
	],
	"./ion-nav_2.entry.js": [
		9594,
		9594
	],
	"./ion-popover.entry.js": [
		4789,
		4789
	],
	"./ion-progress-bar.entry.js": [
		7292,
		7292
	],
	"./ion-radio_2.entry.js": [
		702,
		702
	],
	"./ion-range.entry.js": [
		9338,
		9338
	],
	"./ion-refresher_2.entry.js": [
		1049,
		1049
	],
	"./ion-reorder_2.entry.js": [
		3582,
		3582
	],
	"./ion-ripple-effect.entry.js": [
		6002,
		6002
	],
	"./ion-route_4.entry.js": [
		7303,
		7303
	],
	"./ion-searchbar.entry.js": [
		4792,
		4792
	],
	"./ion-segment_2.entry.js": [
		5632,
		5632
	],
	"./ion-select_3.entry.js": [
		3704,
		3704
	],
	"./ion-slide_2.entry.js": [
		6135,
		6135
	],
	"./ion-spinner.entry.js": [
		4533,
		4533
	],
	"./ion-split-pane.entry.js": [
		3063,
		3063
	],
	"./ion-tab-bar_2.entry.js": [
		5716,
		5716
	],
	"./ion-tab_2.entry.js": [
		932,
		932
	],
	"./ion-text.entry.js": [
		7640,
		7640
	],
	"./ion-textarea.entry.js": [
		2650,
		2650
	],
	"./ion-toast.entry.js": [
		8247,
		8247
	],
	"./ion-toggle.entry.js": [
		4902,
		4902
	],
	"./ion-virtual-scroll.entry.js": [
		9885,
		9885
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5390;
module.exports = webpackAsyncContext;